// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4167":"css/app.6748","9554":"css/admin-app.6748"}[chunkId] + ".css";
};